export default __webpack_public_path__ + "static/media/sms.1633d5d3.svg";